<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_0",
      next: "P_2",
      topic: "¿Estoy listo para cursar esta lección?",
      progress: false
    };
  }
};
</script>

<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          v-card(flat)
            v-card-text.label16tt.withDivider
              | TALLER ¿QUÉ ES CRÉDITO?
            v-card-text.titulo36Book
              | ¡Ya estoy listo para cursar esta lección!
            p(text-xs-start)
              v-img(style='width:100%;', :src='require("@/assets/TCC-L1-Pagina1 A.png")')
              .parrafoDestacado18
                | En esta sección, podrás compartirnos tus ideas generales sobre los créditos.
            v-btn.btn(justify-space-between, type='button', color='primary', @click.prevent="nextPage(next)")

              | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

